// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2Rnrt","footer":"Form_footer__bWYIw"};